import SmallCard from './SmallCard';
import type { SmallCardProps } from './SmallCard.types';

export type { SmallCardProps };
export default SmallCard;
